/**
 * Sticky Section Functionality
 * Adds dynamic shadow effects and handles sticky behavior
 */

class StickySection {
  constructor() {
    this.stickySections = document.querySelectorAll('.sticky-section');
    this.init();
  }

  init() {
    if (this.stickySections.length === 0) return;

    // Use Intersection Observer to detect when sections become sticky
    this.observeStickySections();
  }

  observeStickySections() {
    const observerOptions = {
      root: null,
      rootMargin: '-1px 0px 0px 0px',
      threshold: [0, 1]
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const section = entry.target;
        
        if (entry.intersectionRatio < 1) {
          // Section is sticky (not fully visible)
          section.classList.add('is-sticky');
        } else {
          // Section is not sticky (fully visible)
          section.classList.remove('is-sticky');
        }
      });
    }, observerOptions);

    this.stickySections.forEach(section => {
      observer.observe(section);
    });
  }

  // Method to handle z-index stacking for multiple sticky sections
  updateZIndexes() {
    this.stickySections.forEach((section, index) => {
      // Higher index = higher z-index to maintain proper stacking order
      if (section instanceof HTMLElement) {
        section.style.zIndex = (10 + index).toString();
      }
    });
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new StickySection();
});

// Re-initialize on theme editor updates
document.addEventListener('shopify:section:load', () => {
  new StickySection();
});
